import { render, staticRenderFns } from "./MarketplaceTemplateSingle.vue?vue&type=template&id=8247f672&"
import script from "./MarketplaceTemplateSingle.vue?vue&type=script&lang=js&"
export * from "./MarketplaceTemplateSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports